export default "__VITE_ASSET__XFibg4IF__"